/* eslint-disable no-useless-concat */
// @ts-nocheck
import React, { useState, useEffect, useRef, useMemo } from 'react'
import {
  useAppKitAccount,
  useAppKitNetwork,
  useAppKit
} from '@reown/appkit/react'
import '../App.css'
import ChadFactoryAbi from '../config/ChadFactoryAbi.json'
import ChadFactoryAbiV2 from '../config/ChadFactoryAbiV2.json'
import '../styles/MainContainer.css'
import Input from '../components/Input.tsx'
import TextArea from '../components/TextArea.tsx'
import {
  writeContract,
  readContract,
  waitForTransactionReceipt
} from '@wagmi/core'
import ClipLoader from 'react-spinners/ClipLoader'
import { toast } from 'react-hot-toast'
import Footer from '../components/Footer.jsx'
import 'react-datepicker/dist/react-datepicker.css'
import TopBar from '../components/TopBar.jsx'
import LogoUploadBox from '../components/LogoUploadBox.jsx'
// import BannerUploadBox from '../components/BannerUploadBox.jsx'
import {
  web3Clients,
  imageUploadUrl,
  ethPriceApiUrl,
  chainLogos,
  feeAmounts,
  initialEth,
  featureAmounts,
  coinNames,
  chainNames1,
  apiUrl
} from '../utils/constants.ts'
import {
  getFactoryAddress,
  getCreatePoolOptions
} from '../utils/addressHelpers.ts'
import { Tooltip } from 'react-tooltip'
// import sampleBanner from '../icons/sampleBanner.svg'
import web from '../icons/website.svg'
import x from '../icons/x-icon.svg'
import tlg from '../icons/telegram.svg'
// import sampleLogo from '../icons/sampleLogo.webp'
// import corcel from '../../public/img/corcel.png'
import { networks, wagmiAdapter } from '../App'
import { encodeFunctionData } from 'viem'
import { switchChain } from '@wagmi/core'
import { supportedChainIds } from '../utils/constants.ts'
import buildBuyLink from '../utils/buildBuyLink.ts'
import { Link } from 'react-router-dom'

const App = () => {
  const { caipNetwork, chainId } = useAppKitNetwork()
  const { open } = useAppKit()
  const { address, isConnected } = useAppKitAccount()
  const [logoPreview, setLogoPreview] = useState<string | null>(null)
  const [logoFile, setLogoFile] = useState<File | null>(null)
  // const [bannerPreview, setBannerPreview] = useState<string | null>(null)
  // const [bannerFile, setBannerFile] = useState<File | null>(null)
  const [logoError, setLogoError] = useState('')
  // const [bannerError, setBannerError] = useState('')
  const logoFileInput = useRef<HTMLInputElement>(null)
  // const bannerFileInput = useRef<HTMLInputElement>(null)
  const [maxWallet, setMaxWallet] = useState(100)
  const [featureOption, setFeatureOption] = useState(0)
  const [selectedChain, setChain] = useState(caipNetwork)
  const [targetChainId, setTargetChainId] = useState<number | undefined>(
    undefined
  )

  useEffect(() => {
    if (!caipNetwork) return
    const currentId =
      selectedChain && 'id' in selectedChain ? selectedChain.id : undefined
    if (targetChainId != null && caipNetwork.id !== targetChainId) return
    if (currentId === caipNetwork.id && targetChainId == null) return
    setChain(caipNetwork)
    setTargetChainId(undefined)
  }, [caipNetwork, selectedChain, targetChainId])
  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenDescription, setTokenDescription] = useState('')
  const [isCorcel, setIsCorcel] = useState(true)
  const [apiKey, setApiKey] = useState('')
  const [personality, setPersonality] = useState('')
  const [touchedFields, setTouchedFields] = useState({
    tokenName: false,
    tokenSymbol: false,
    tokenDescription: false
  })
  let [loading, setLoading] = useState(false)
  let [creating, setCreating] = useState(false)
  const [website, setWebsite] = useState('')
  const [telegram, setTelegram] = useState('')
  const [twitter, setTwitter] = useState('')
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [discord, setDiscord] = useState('')
  const [depositAmount, setDepositAmount] = useState('')
  const [accountBalance, setAccountBalance] = useState(0)
  const [isChecked, setIsChecked] = useState(false)
  const [showMoreOptions, setShowMoreOptions] = useState(false)

  const numericChainId =
    typeof chainId === 'number' ? chainId : Number(chainId ?? 0)

  const chainIdFromSelection = (() => {
    if (selectedChain && typeof selectedChain.id === 'number') {
      return selectedChain.id
    }
    if (selectedChain && typeof selectedChain.id === 'string') {
      const parsed = Number(selectedChain.id)
      return Number.isFinite(parsed) ? parsed : undefined
    }
    return undefined
  })()

  const poolChainId =
    (chainIdFromSelection && Number.isFinite(chainIdFromSelection)
      ? Number(chainIdFromSelection)
      : undefined) ??
    (Number.isFinite(numericChainId) && numericChainId > 0
      ? numericChainId
      : undefined)

  const poolOptions = useMemo(
    () => getCreatePoolOptions(poolChainId),
    [poolChainId]
  )

  const [selectedPoolId, setSelectedPoolId] = useState(
    () => poolOptions[0]?.id || ''
  )

  useEffect(() => {
    if (poolOptions.length === 0) {
      if (selectedPoolId !== '') setSelectedPoolId('')
      return
    }
    if (!poolOptions.some(option => option.id === selectedPoolId)) {
      setSelectedPoolId(poolOptions[0].id)
    }
  }, [poolOptions, selectedPoolId])

  const selectedPool = useMemo(
    () =>
      poolOptions.find(option => option.id === selectedPoolId) ||
      (poolOptions.length ? poolOptions[0] : null),
    [poolOptions, selectedPoolId]
  )

  const isV2Pool = selectedPool?.version === 'v2'
  const selectedPoolChainId = selectedPool?.chainId ?? poolChainId ?? 0
  const uiChainId = selectedPoolChainId
  const chainCoinName = coinNames[selectedPoolChainId] ?? 'ETH'
  const chainFeatureAmounts = featureAmounts[selectedPoolChainId] ?? []
  const chainFeeAmount = feeAmounts[selectedPoolChainId] ?? 0

  useEffect(() => {
    const fetchBalance = async () => {
      if (!address) return
      const client = web3Clients[numericChainId]
      if (!client || !client.eth) return
      let nextBalance = await client.eth.getBalance(address)
      nextBalance = client.utils.fromWei(nextBalance, 'ether')
      setAccountBalance(nextBalance)
    }
    if (address) {
      fetchBalance()
    }
  }, [address, numericChainId])

  useEffect(() => {
    if (loading === true) {
      setTimeout(function () {
        setLoading(false)
      }, 3000)
    }
  }, [loading])

  const simulateWithTenderly = async (value, factoryAddress, factoryAbi, args) => {
    if (!factoryAddress || !Array.isArray(factoryAbi) || factoryAbi.length === 0)
      return undefined
    const resolvedChainId = Number.isFinite(numericChainId)
      ? numericChainId
      : Number(chainId)
    if (!resolvedChainId || resolvedChainId <= 0) return undefined
    const TENDERLY_USER = 'stevejobless'
    const TENDERLY_PROJECT = 'hotcurves'
    const TENDERLY_ACCESS_KEY = 'yy52llNbzKaBjRgCKuGEsE3kqzt5X-tS'

    const endpoint = `https://api.tenderly.co/api/v1/account/${TENDERLY_USER}/project/${TENDERLY_PROJECT}/simulate`
    const encodedData = encodeFunctionData({
      abi: factoryAbi,
      functionName: 'createHotLaunch',
      args
    })
    const txData = {
      network_id: resolvedChainId.toString(),
      from: address,
      to: factoryAddress,
      input: encodedData, // You must encode this properly!
      gas: 1000000000,
      gas_price: '0',
      value: value.toString(),
      save_if_fails: false,
      save: false
    }

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'X-Access-Key': TENDERLY_ACCESS_KEY,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(txData)
      })

      const data = await res.json()

      if (!res.ok) {
        throw new Error(JSON.stringify(data))
      }

      return data.simulation.gas_used
    } catch (err) {
      console.error('🔥 Tenderly simulation error:', err)
    }
  }

  const onHotcurveCreate = async () => {
    try {
      setCreating(true)
      const pool = selectedPool
      if (!pool) {
        setCreating(false)
        toast.error('no pool available for the selected network')
        return false
      }
      const activeChainId = pool.chainId
      if (
        Number.isFinite(numericChainId) &&
        numericChainId > 0 &&
        numericChainId !== activeChainId
      ) {
        setCreating(false)
        toast.error('switch wallet network to match the selected pool')
        return false
      }

      const factoryAddress =
        pool.factoryAddress || getFactoryAddress(activeChainId)
      const factoryAbi = isV2Pool ? ChadFactoryAbiV2 : ChadFactoryAbi
      if (!factoryAddress) {
        setCreating(false)
        toast.error('missing factory address for selected pool')
        return false
      }
      if (isV2Pool && !pool.routerAddress) {
        setCreating(false)
        toast.error('please select a router for v2 deployments')
        return false
      }

      let feeAmount = feeAmounts[activeChainId] ?? 0
      let featuredAmount = featureAmounts[activeChainId]?.[featureOption] ?? 0

      if (Number(depositAmount) > 0) {
        let newEthAmount =
          Number(initialEth[activeChainId] ?? 1) + Number(depositAmount)
        let newTokenAmount =
          (1073 * 10 ** 6 * Number(initialEth[activeChainId])) / newEthAmount
        let tokenAmount = 1073 * 10 ** 6 - newTokenAmount
        let maxAmount = (1000000000 * maxWallet) / 100

        if (tokenAmount > maxAmount) {
          setCreating(false)
          toast.error(
            "You can't purchase more than " +
              ' ' +
              maxAmount.toLocaleString() +
              ' ' +
              ' tokens'
          )
          return false
        }
      }
      if (logoFile) {
        const tokenDataArgs = [
          String(tokenName),
          String(tokenSymbol),
          String(tokenDescription),
          String(website),
          String(twitter),
          String(telegram),
          String(discord)
        ]
        const factoryArgs = isV2Pool
          ? [
              tokenDataArgs,
              maxWallet.toString(),
              String(pool.routerAddress),
              featureOption.toString()
            ]
          : [tokenDataArgs, maxWallet.toString(), featureOption.toString()]

        const client = web3Clients[activeChainId]
        if (!client || !client.utils || !client.utils.toWei) {
          setCreating(false)
          toast.error('missing web3 client for selected chain')
          return false
        }

        let funAddresses = await readContract(wagmiAdapter.wagmiConfig, {
          address: factoryAddress,
          abi: factoryAbi,
          functionName: 'getAllAddresses',
          chainId: activeChainId
        })
        let presaleAddress = funAddresses
          ? funAddresses[funAddresses.length - 1]
          : null
        const transactionValueWei = client.utils.toWei(
          String(feeAmount + Number(depositAmount) + featuredAmount),
          'ether'
        )
        const gasLimit = await simulateWithTenderly(
          transactionValueWei,
          factoryAddress,
          factoryAbi,
          factoryArgs
        )
        let create = await writeContract(wagmiAdapter.wagmiConfig, {
          address: factoryAddress,
          abi: factoryAbi,
          functionName: 'createHotLaunch',
          value: transactionValueWei,
          args: factoryArgs,
          gas: gasLimit ? Math.round(gasLimit * 1.2) : undefined,
          chainId: activeChainId
        })
        toast.success(`Transaction submitted`)
        await waitForTransactionReceipt(wagmiAdapter.wagmiConfig, {
          hash: create
        })

        let newPresaleAddress
        while (true) {
          let funAddresses1 = await readContract(wagmiAdapter.wagmiConfig, {
            address: factoryAddress,
            abi: factoryAbi,
            functionName: 'getAllAddresses',
            chainId: activeChainId
          })
          newPresaleAddress = funAddresses1
            ? funAddresses1[funAddresses1.length - 1]
            : null

          if (presaleAddress !== newPresaleAddress) {
            break
          }
          await new Promise(resolve => setTimeout(resolve, 1000))
        }

        // Single addAgent call: set all info at once (no auth required here)
        try {
          const API_BASE = (apiUrl || '').replace(/\/$/, '')
          const addAgentUrl = `${API_BASE}/api/addAgent?chainId=${Number(
            activeChainId
          )}`
          const payload: any = {
            tokenAddress: String(newPresaleAddress || '').toLowerCase().trim(),
            creator: String(address || '').toLowerCase().trim(),
            chainId: Number(activeChainId)
          }
        if (isChecked) {
          payload.apiKey = apiKey || ''
          payload.personality = personality || ''
          payload.isCorcel = !!isCorcel
          payload.provider = isCorcel ? 'corcel' : 'openai'
        }

          const res = await fetch(addAgentUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            redirect: 'error',
            body: JSON.stringify(payload)
          })
          if (!res.ok) {
            const text = await res.text().catch(() => '')
            console.warn('addAgent non-OK:', res.status, res.statusText, text)
            // Non-blocking: proceed with flow even if this fails
          }
        } catch (e) {
          console.warn('addAgent request error:', e)
          // Non-blocking: proceed with flow even if this fails
        }
        let logoUrl
        if (logoFile) {
          const formData = new FormData()

          formData.append(
            'file',
            logoFile,
            `${newPresaleAddress}-${activeChainId}`
          )
          fetch(imageUploadUrl + 'api/logoUploads', {
            method: 'POST',
            body: formData
          })
            .then(async res => {
              logoUrl = await res.json()
              logoUrl = logoUrl.fileInfo.filename
              toast.success(`successfully created ${tokenName}`)
              const link = buildBuyLink(
                activeChainId,
                newPresaleAddress,
                pool.version
              )
              window.location.href = link
            })
            .catch(error => {
              setCreating(false)
              console.error('Error:', error)
            })
        }
        setCreating(false)
      } else {
        setCreating(false)
        toast.error('please upload a valid image file')
      }
    } catch (err) {
      setCreating(false)
      console.error(err)
      toast.error('error while creating coin. please try again later')
    }
  }

  const [, setImageLogoFile] = useState(null)

  const handleImageLogoChange = file => {
    setImageLogoFile(file)
  }

  /* 
  const [, setImageBannerFile] = useState(null)

  const handleImageBannerChange = file => {
    setImageBannerFile(file)
  }
  */

  const LogoImageUpload = ({ onChange, className, style }) => {
    const handleFileDrop = (file: File) => {
      if (file.size > 1048576) {
        toast.error("logo size can't be greater than 1mb.")
        return
      }
      setLogoFile(file)
      setLogoPreview(URL.createObjectURL(file))
      onChange(file)
    }

    const handleLogoImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files![0]
      const fileType = selectedFile.type
      const isValidType = ['image/png', 'image/jpeg', 'image/jpg'].includes(
        fileType
      )
      if (!isValidType) {
        setLogoError('only .png, .jpg or .jpeg files are allowed.')
        setLogoFile(null)
        setLogoPreview(null)
        return
      }
      if (selectedFile.size > 1048576) {
        setLogoError('logo must be smaller than 1mb')
        setLogoFile(null)
        setLogoPreview(null)
        return
      }
      setLogoError('')
      setLogoFile(selectedFile)
      setLogoPreview(URL.createObjectURL(selectedFile))
      onChange(selectedFile)
    }

    const onButtonClick = () => {
      if (logoFileInput.current) {
        logoFileInput.current.click()
      }
    }

    return (
      <div className="relative w-full overflow-hidden rounded-lg">
        {logoPreview && (
          <img
            src={logoPreview}
            alt="Logo Preview"
            className="absolute inset-0 top-[17px] w-full h-full object-cover object-center rounded-[12px] z-0 opacity-30 pointer-events-none"
          />
        )}
        <input
          type="file"
          ref={logoFileInput}
          accept="image/*"
          onChange={handleLogoImageChange}
          style={{ display: 'none' }}
        />
        <LogoUploadBox
          handleClick={onButtonClick}
          onFileDrop={handleFileDrop}
          className={className}
          style={style}
          error={!!logoError}
        />
      </div>
    )
  }

  /* 
  const BannerImageUpload = ({ onChange, className, style }) => {
    const handleFileDrop = (file: File) => {
      if (file.size > 1048576) {
        toast.error("banner size can't be greater than 1mb.");
        return;
      }
      setBannerFile(file);
      setBannerPreview(URL.createObjectURL(file));
      onChange(file);
    };

    const handleBannerImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const selectedFile = e.target.files![0];
      const fileType = selectedFile.type;
      const isValidType = ['image/png', 'image/jpeg', 'image/jpg'].includes(fileType);
      if (!isValidType) {
        setBannerError('only .png, .jpg or .jpeg files are allowed.');
        setBannerFile(null);
        setBannerPreview(null);
        return;
      }
      if (selectedFile.size > 1048576) {
        setBannerError("banner size can't be greater than 1mb.");
        setBannerFile(null);
        setBannerPreview(null);
        return;
      }
      setBannerError('');
      setBannerFile(selectedFile);
      setBannerPreview(URL.createObjectURL(selectedFile));
      onChange(selectedFile);
    };

    const onButtonClick = () => {
      if (bannerFileInput.current) {
        bannerFileInput.current.click();
      }
    };

    return (
      <div className="relative w-full overflow-hidden rounded-lg">
        {bannerPreview && (
          <img
            src={bannerPreview}
            alt="Banner Preview"
            className="absolute inset-0 top-[17px] w-full h-full object-cover object-center rounded-[12px] z-0 opacity-30 pointer-events-none"
          />
        )}
        <input
          type="file"
          ref={bannerFileInput}
          accept="image/*"
          onChange={handleBannerImageChange}
          style={{ display: 'none' }}
        />
        <BannerUploadBox
          handleClick={onButtonClick}
          onFileDrop={handleFileDrop}
          className={className}
          style={style}
          error={!!bannerError}
        />
      </div>
    );
  }
  */

  const setMaxWalletAmount = value => {
    setMaxWallet(value)
  }

  const changeChain = async network => {
    try {
      // First, request wallet to switch chain
      await switchChain(wagmiAdapter.wagmiConfig, {
        chainId: network.id
      })

      // Then, update UI state
      setChain(network)
      setTargetChainId(network.id)
      const nextOptions = getCreatePoolOptions(network.id)
      setSelectedPoolId(nextOptions[0]?.id || '')
    } catch (err) {
      toast.error('please approve network switch in your wallet')
      console.error('switch chain error:', err)
    }
  }

  const handleCheckboxChange = () => {
    setIsChecked(prev => !prev)
  }

  return (
    <div>
      <div className="GlobalContainer launches-all-padding">
        {
          <div style={{ zIndex: 1 }}>
            <TopBar />
            <div className="h-20 sm:h-0" aria-hidden="true" />
            <div className="max-w-[90rem] m-auto pb-8 px-2 sm:px-3 py-3">
              <section className="lg:mx-auto pt-8 lg:py-[30px] w-full min-w-0">
                <div className="mb-2">
                  <Link
                    to="/"
                    className="inline-flex items-center gap-1 text-[#f500ff] hover:text-[#f8ffe8] hover:underline"
                  >
                    ← Go Back
                  </Link>
                </div>
                <section>
                  <div className="flex flex-col md:flex-row gap-3">
                    <div className="flex flex-col gap-2 grow">
                      <h1 className="flex text-[#f8ffe8] w-full text-[20px] font-bold">
                        token details
                      </h1>
                      <div className="flex flex-col gap-2 w-full">
                        <div className="flex flex-col md:flex-row gap-2 w-full">
                          <section
                            className={`flex-col w-full px-[10px] py-[10px] rounded-lg ${
                              touchedFields.tokenName
                                ? tokenName === ''
                                  ? 'border-2 border-red-500'
                                  : 'border-2 border-green-500'
                                : 'border border-[#2a2d36]'
                            } bg-[#171a21]`}
                          >
                            <div className="Name">
                              <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80">
                                name
                                <span className="ml-1 text-[14px] font-bold text-[#ff4d4f]">
                                  *
                                </span>
                              </p>
                            </div>
                            <Input
                              placeholder=""
                              label=""
                              type="text"
                              changeValue={val => {
                                setTokenName(val)
                                setTouchedFields(prev => ({
                                  ...prev,
                                  tokenName: true
                                }))
                              }}
                              value={tokenName}
                              className={`rounded-lg`}
                            />
                            {touchedFields.tokenName && tokenName === '' && (
                              <p className="text-red-500 text-xs mt-1">
                                name is required
                              </p>
                            )}
                          </section>

                          <section
                            className={`flex-col w-full px-[10px] py-[10px] rounded-lg ${
                              touchedFields.tokenSymbol
                                ? tokenSymbol === ''
                                  ? 'border-2 border-red-500'
                                  : 'border-2 border-green-500'
                                : 'border border-[#2a2d36]'
                            } bg-[#171a21]`}
                          >
                            <div className="Ticker">
                              <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80">
                                ticker
                                <span className="ml-1 text-[14px] font-bold text-[#ff4d4f]">
                                  *
                                </span>
                              </p>
                            </div>
                            <Input
                              placeholder=""
                              label=""
                              type="text"
                              changeValue={val => {
                                setTokenSymbol(val)
                                setTouchedFields(prev => ({
                                  ...prev,
                                  tokenSymbol: true
                                }))
                              }}
                              value={tokenSymbol}
                              className="rounded-lg"
                            />
                            {touchedFields.tokenSymbol &&
                              tokenSymbol === '' && (
                                <p className="text-red-500 text-xs mt-1">
                                  ticker is required
                                </p>
                              )}
                          </section>
                        </div>

                        <section
                          className={`flex-col w-full px-[10px] py-[10px] rounded-lg ${
                            touchedFields.tokenDescription
                              ? tokenDescription.length > 1000 ||
                                tokenDescription.length === 0
                                ? 'border-2 border-red-500'
                                : 'border-2 border-green-500'
                              : 'border border-[#2a2d36]'
                          } bg-[#171a21]`}
                        >
                          <div className="Description">
                            <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80">
                              description
                              <span className="ml-1 text-[14px] font-bold text-[#ff4d4f]">
                                *
                              </span>
                            </p>
                            <TextArea
                              rows={4}
                              placeholder=""
                              changeValue={val => {
                                setTokenDescription(val)
                                setTouchedFields(prev => ({
                                  ...prev,
                                  tokenDescription: true
                                }))
                              }}
                              value={tokenDescription}
                            />
                            <div
                              className={`text-xs mt-1 ${
                                tokenDescription.length > 1000
                                  ? 'text-red-500'
                                  : 'text-gray-400'
                              }`}
                            >
                              {tokenDescription.length}/1000 characters
                            </div>
                            {touchedFields.tokenDescription &&
                              tokenDescription.length === 0 && (
                                <p className="text-red-500 text-xs mt-1">
                                  description is required
                                </p>
                              )}
                          </div>
                        </section>

                        <div className="flex-col md:flex-row gap-7 w-full">
                          <section
                            className={`flex-col w-full px-[10px] py-[10px] rounded-lg ${
                              logoFile
                                ? 'border-2 border-green-500'
                                : logoError
                                ? 'border-2 border-red-500'
                                : 'border border-[#2a2d36]'
                            } bg-[#171a21]`}
                          >
                            <div className="UploadLogo">
                              <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80 flex items-center gap-2 mb-2">
                                <span>
                                  image
                                  <span className="ml-1 text-[14px] font-bold text-[#ff4d4f]">
                                    *
                                  </span>
                                </span>
                                <a
                                  className="flex items-center"
                                  id="my-anchor-element"
                                >
                                  <Tooltip
                                    anchorSelect="#my-anchor-element"
                                    className="rounded-lg border border-[#2a2d36] bg-[#171a21]/95 w-64 md:w-80 lg:w-96 max-w-sm"
                                    content="only .png, .jpg. ideal size: 256x256."
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </p>
                            </div>
                            <LogoImageUpload
                              onChange={handleImageLogoChange}
                              className={'cursor-pointer'}
                              style={undefined}
                            />
                            {logoError && (
                              <p className="text-red-500 text-xs mt-1">
                                {logoError}
                              </p>
                            )}
                          </section>

                          {/* 
                          <section className={`flex-col w-full px-[10px] py-[10px] rounded-lg ${bannerFile ? 'border-2 border-green-500' : bannerError ? 'border-2 border-red-500' : 'border border-[#2c2c2c]'} bg-[#171a21]`}>
                            <div className="UploadBanner">
                              <p className="text-left text-[12px] font-semibold text-[#e2e2e2] flex justify-between items-center">
                                upload banner
                                <span className="ml-1 text-[14px] font-bold text-[#ff4d4f]">*</span>
                                <a className='flex pl-8 text-[#d3d3d3]' id="banner-anchor-element">
                                  <Tooltip
                                    anchorSelect="#banner-anchor-element"
                                    className='w-64 md:w-80 lg:w-96 max-w-sm'
                                    content="upload only images in .png, .jpg. the ideal size for uploads is 1200x600 pixels for optimal quality and fit."
                                  />
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </a>
                              </p>
                            </div>
                            <BannerImageUpload
                              onChange={handleImageBannerChange}
                              className={'cursor-pointer'}
                              style={undefined}
                            />
                            {bannerError && (
                              <p className="text-red-500 text-xs mt-1">{bannerError}</p>
                            )}
                          </section>
                          */}
                        </div>

                        {/* 
                        <section className="corcel">
                          <div className="flex justify-start items-center">
                            <a
                              href="https://app.corcel.io"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center justify-start gap-2 rounded-full px-10 py-1 hover:opacity-90 transition-opacity"
                              style={{
                                backgroundColor: '#252423',
                                border: '0px solid #ffffff',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
                                textDecoration: 'none',
                              }}
                            >
                              <img
                                src={corcel}
                                alt="Button Icon"
                                className="w-ful h-6 rounded-full"
                              />
                            </a>
                          </div>
                        </section>
                        */}

                        <div className="grid grid-cols-2 gap-2 w-full">
                          <section className="flex-col gap-2 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                            <div className="Network">
                              <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80">
                                network
                              </p>
                            </div>
                            <div className="fairlaunch-allocation-buttons-container">
                              {networks
                                .filter(network =>
                                  supportedChainIds.includes(network.id)
                                )
                                .map(network => (
                                  <button
                                    key={network.id}
                                    className={`${
                                      selectedChain?.id === network.id
                                        ? 'opacity-100'
                                        : 'opacity-30'
                                    }`}
                                    onClick={() => {
                                      changeChain(network)
                                    }}
                                  >
                                    <img
                                      src={chainLogos[network.id]}
                                      alt="chain"
                                      className="w-8"
                                    />
                                  </button>
                                ))}
                            </div>
                          </section>
                          <section className="flex-col gap-2 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                            <div className="Dex">
                              <p className="text-left text-[12px] font-semibold text-[#e2e2e2] flex justify-between items-center">
                                pool
                              </p>
                            </div>
                            <div className="fairlaunch-allocation-buttons-container">
                              {poolOptions.length === 0 ? (
                                <span className="text-xs text-[#f8ffe8]/60">
                                  no pools available on this network
                                </span>
                              ) : (
                                poolOptions.map(option => (
                                  <button
                                    key={option.id}
                                    onClick={() => setSelectedPoolId(option.id)}
                                    className={`inline-flex items-center px-3 py-1 rounded-lg border transition-colors hover:translate-y-[-1px] text-xs ${
                                      selectedPool?.id === option.id
                                        ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                        : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                                    }`}
                                    aria-pressed={selectedPool?.id === option.id}
                                  >
                                    {option.label}
                                    <span className="ml-1 text-[10px] uppercase text-[#f8ffe8]/60">
                                      {option.version}
                                    </span>
                                  </button>
                                ))
                              )}
                            </div>
                          </section>
                        </div>

                        <button
                          onClick={() => setShowMoreOptions(prev => !prev)}
                          className="flex items-center gap-2 text-white text-sm font-semibold hover:underline transition-all mb-2"
                        >
                          {showMoreOptions
                            ? 'hide extra options'
                            : 'show more options'}
                          <svg
                            className={`w-4 h-4 transform transition-transform ${
                              showMoreOptions ? 'rotate-180' : 'rotate-0'
                            }`}
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M19 9l-7 7-7-7"
                            />
                          </svg>
                        </button>
                        {showMoreOptions && (
                          <>
                            <div className="flex flex-col md:flex-row gap-2">
                              <section className="flex-col w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="Website">
                                  <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80">
                                    website link
                                  </p>
                                </div>
                                <Input
                                  placeholder="(optional)"
                                  className="text-xs placeholder:text-[11px]"
                                  label=""
                                  type="text"
                                  changeValue={setWebsite}
                                  value={website}
                                />
                              </section>
                              <section className="flex-col w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="Twitter">
                                  <p className="text-left text-[12px] font-semibold text-[#e2e2e2]">
                                    twitter or x link
                                  </p>
                                </div>
                                <Input
                                  placeholder="(optional)"
                                  className="text-xs placeholder:text-[11px]"
                                  label=""
                                  type="text"
                                  changeValue={setTwitter}
                                  value={twitter}
                                />
                              </section>
                              <section className="flex-col w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="Telegram">
                                  <p className="text-left text-[12px] font-semibold text-[#e2e2e2]">
                                    telegram link
                                  </p>
                                </div>
                                <Input
                                  placeholder="(optional)"
                                  className="text-xs placeholder:text-[11px]"
                                  label=""
                                  type="text"
                                  changeValue={setTelegram}
                                  value={telegram}
                                />
                              </section>
                            </div>

                            <div className="flex flex-col gap-2 w-full">
                              <section className="flex-col gap-4 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="MaxWallet">
                                  <p className="text-left text-[12px] font-semibold text-[#e2e2e2] flex items-center gap-2 mb-2">
                                    <span>max wallet (%)</span>
                                    <a
                                      className="flex items-center"
                                      id="maxwallet-anchor-element"
                                    >
                                      <Tooltip
                                        anchorSelect="#maxwallet-anchor-element"
                                        className="rounded-lg border border-[#2a2d36] bg-[#171a21]/95 w-64 md:w-80 lg:w-96 max-w-sm"
                                        content="sets max % per wallet. 1% or 2% blocks whales. limit removed on migration."
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </p>
                                </div>
                                <section className="inputPanel">
                                  <section className="inputPanelHeader">
                                    <div className="flex flex-wrap gap-2">
                                      {[100, 1, 2].map(value => {
                                        const label =
                                          value === 100
                                            ? 'no limit'
                                            : `${value}%`
                                        return (
                                          <button
                                            key={label}
                                            onClick={() =>
                                              setMaxWalletAmount(value)
                                            }
                                            className={`inline-flex items-center px-2 py-1 rounded-lg border transition-colors hover:translate-y-[-1px] text-xs ${
                                              maxWallet === value
                                                ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                                : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                                            }`}
                                            aria-pressed={maxWallet === value}
                                          >
                                            {label}
                                          </button>
                                        )
                                      })}
                                    </div>
                                  </section>
                                </section>
                              </section>
                              <section className="flex-col gap-4 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="Bundle">
                                  <p className="text-left text-[12px] font-semibold text-[#e2e2e2] flex items-center gap-2 mb-2">
                                    <span>bundle amount</span>
                                    <a
                                      className="flex items-center"
                                      id="snipe-anchor-element"
                                    >
                                      <Tooltip
                                        anchorSelect="#snipe-anchor-element"
                                        className="rounded-lg border border-[#2a2d36] bg-[#171a21]/95 w-64 md:w-80 lg:w-96 max-w-sm"
                                        content="amount you auto-buy at launch. makes you first holder."
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </p>
                                </div>
                                <section className="inputPanel">
                                  <section className="inputPanelHeader w-full">
                                    <div className="w-full flex flex-col gap-2">
                                      <div className="flex items-center gap-2">
                                        <img
                                          src={chainLogos[uiChainId]}
                                          alt="Chain Logo"
                                          className="w-5 h-5"
                                        />
                                        <span className="text-xs text-[#f8ffe8]/80">
                                          {chainCoinName}
                                        </span>
                                        <Input
                                          placeholder="(optional)"
                                          className="text-xs placeholder:text-[11px] w-full text-right"
                                          label=""
                                          type="number"
                                          changeValue={val => {
                                            if (Number(val) >= 0)
                                              setDepositAmount(val)
                                          }}
                                          value={depositAmount}
                                        />
                                      </div>
                                      <div className="flex justify-end gap-2">
                                        {[
                                          'reset',
                                          '0.05',
                                          '0.1',
                                          '0.25',
                                          '0.5',
                                          '1'
                                        ].map(val => (
                                          <button
                                            key={val}
                                            onClick={() =>
                                              setDepositAmount(
                                                val === 'reset' ? '' : val
                                              )
                                            }
                                            className="inline-flex items-center px-3 py-1 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 text-[11px] font-bold text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                                          >
                                            {val}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  </section>
                                </section>
                              </section>
                              <section className="flex-col gap-4 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                                <div className="Featured">
                                  <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80 flex items-center gap-2 mb-2">
                                    <span>featured listing option</span>
                                    <a
                                      className="flex items-center"
                                      id="feature-anchor-element"
                                    >
                                      <Tooltip
                                        anchorSelect="#feature-anchor-element"
                                        className="rounded-lg border border-[#2a2d36] bg-[#171a21]/95 w-64 md:w-80 lg:w-96 max-w-sm"
                                        content={`show on homepage featured section.`}
                                      />
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </a>
                                  </p>
                                </div>
                                <section className="inputPanel">
                                  <section className="inputPanelHeader">
                                    <div className="fairlaunch-allocation-buttons-container flex flex-wrap gap-2">
                                      {[
                                        { label: 'basic (free)', value: 0 },
                                        {
                                          label: `1 week (${chainFeatureAmounts?.[1] ?? 0} ${chainCoinName})`,
                                          value: 1
                                        },
                                        {
                                          label: `2 weeks (${chainFeatureAmounts?.[2] ?? 0} ${chainCoinName})`,
                                          value: 2
                                        },
                                        {
                                          label: `4 weeks (${chainFeatureAmounts?.[3] ?? 0} ${chainCoinName})`,
                                          value: 3
                                        }
                                      ].map(({ label, value }) => (
                                        <button
                                          key={label}
                                          onClick={() =>
                                            setFeatureOption(value)
                                          }
                                          className={`inline-flex items-center px-2 py-1 rounded-lg border transition-colors hover:translate-y-[-1px] text-xs ${
                                            featureOption === value
                                              ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                              : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/90 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                                          }`}
                                          aria-pressed={featureOption === value}
                                        >
                                          {label}
                                        </button>
                                      ))}
                                    </div>
                                  </section>
                                </section>
                              </section>
                            </div>

                          <div className="relative flex items-center text-[#f8ffe8] w-full text-[20px] font-bold">
                            agent details
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                              className="absolute left-1/2 -translate-x-1/2 w-full h-full peer appearance-none rounded-lg"
                            />
                            <span className="w-12 h-6 flex items-center flex-shrink-0 ml-4 p-1 bg-[#919191] rounded-full duration-300 ease-in-out peer-checked:bg-[#530758] peer-checked:after:bg-[#e0f] after:w-6 after:h-6 after:bg-gray-300 after:rounded-full after:shadow-md after:duration-300 peer-checked:after:translate-x-4"></span>
                          </div>
                          <div
                            className={`${
                              isChecked ? 'grid' : 'hidden'
                            } grid-cols-1 md:grid-cols-2 gap-2 w-full`}
                          >
                            <section className="flex-col gap-4 w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                              <div className="APIKeyProvider">
                                <p className="text-left text-[12px] font-semibold text-[#f8ffe8]/80 flex items-center gap-2 mb-2">
                                  <span>api key provider</span>
                                  <a
                                    className="flex items-center"
                                    id="KeyProvider-anchor-element"
                                  >
                                    <Tooltip
                                      anchorSelect="#KeyProvider-anchor-element"
                                      className="rounded-lg border border-[#2a2d36] bg-[#171a21]/95 w-64 md:w-80 lg:w-96 max-w-sm"
                                      content={`Choose your Provider`}
                                    />
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 20 20"
                                      fill="currentColor"
                                      className="h-4 w-4 text-[#c378fb] hover:text-[#e0f] align-middle transition-colors duration-200"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-4.25a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5zM10 7a.75.75 0 00-.75.75v3.5a.75.75 0 001.5 0v-3.5A.75.75 0 0010 7z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                  </a>
                                </p>
                              </div>
                              <section className="inputPanel">
                                <section className="inputPanelHeader">
                                  <div className="fairlaunch-allocation-buttons-container">
                                    <div className="flex flex-wrap gap-2">
                                      <button
                                        onClick={() => setIsCorcel(true)}
                                        className={`inline-flex items-center px-3 py-1 rounded-lg border transition-colors hover:translate-y-[-1px] text-sm font-bold ${
                                          isCorcel === true
                                            ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                            : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/70 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                                        }`}
                                      >
                                        corcel
                                      </button>
                                      <button
                                        onClick={() => setIsCorcel(false)}
                                        className={`inline-flex items-center px-3 py-1 rounded-lg border transition-colors hover:translate-y-[-1px] text-sm font-bold ${
                                          isCorcel === false
                                            ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                            : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/70 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                                        }`}
                                      >
                                        openai
                                      </button>
                                    </div>
                                  </div>
                                </section>
                              </section>
                            </section>
                            <section className="flex-col w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                              <div className="APIKey">
                                <p
                                  className="text-[12px] font-semibold text-[#f8ffe8]/80"
                                  style={{ order: '0' }}
                                >
                                  api key
                                </p>
                              </div>
                              <TextArea
                                rows={4}
                                placeholder=""
                                changeValue={setApiKey}
                                value={apiKey}
                              />
                            </section>
                            <section className="md:col-span-2 flex-col w-full bg-[#171a21] px-[10px] py-[10px] rounded-lg">
                              <div className="Personality">
                                <p
                                  className="text-[12px] font-semibold text-[#f8ffe8]/80"
                                  style={{ order: '0' }}
                                >
                                  personality
                                </p>
                              </div>
                              <TextArea
                                rows={4}
                                placeholder=""
                                changeValue={setPersonality}
                                value={personality}
                              />
                            </section>
                          </div>
                          </>
                        )}
                      </div>
                    </div>

                    <aside className="w-full md:w-[360px]">
                      <div className="group flex flex-col gap-3 w-full rounded-lg bg-[#171a21] border border-[#2a2d36] px-4 py-5 shadow-sm transition-all duration-200">
                        {/* 
                        <div className="relative w-full aspect-[3/1] overflow-hidden z-40">
                          <img alt="banner" loading="lazy"
                            decoding="async" data-nimg="fill"
                            className="w-full h-full object-cover group-hover:scale-[1.035] transition-all ease-in-out duration-500"
                            src={bannerPreview ? bannerPreview : sampleBanner} />
                        </div>
                        */}
                        <div className="flex flex-col gap-[16px] w-full transition-all ease-in-out duration-150">
                          <div className="token-header flex items-start gap-4 w-full">
                            <div className="token-profile flex gap-4 flex-grow overflow-hidden">
                              {logoPreview ? (
                                <img
                                  alt="logo"
                                  src={logoPreview}
                                  className="w-[50px] h-[50px] rounded-lg object-cover"
                                />
                              ) : (
                                <svg
                                  viewBox="0 0 200 200"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-[50px] h-[50px] rounded-full bg-[#1e1b2e] p-1"
                                >
                                  <circle
                                    cx="100"
                                    cy="100"
                                    r="95"
                                    fill="#78d361"
                                    stroke="#3e3e3e"
                                    strokeWidth="5"
                                  />
                                  <circle
                                    cx="70"
                                    cy="80"
                                    r="15"
                                    fill="#ffffff"
                                  />
                                  <circle
                                    cx="130"
                                    cy="80"
                                    r="15"
                                    fill="#ffffff"
                                  />
                                  <circle
                                    cx="75"
                                    cy="80"
                                    r="5"
                                    fill="#000000"
                                  />
                                  <circle
                                    cx="135"
                                    cy="80"
                                    r="5"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M60,130 Q100,160 140,130"
                                    stroke="#000000"
                                    strokeWidth="4"
                                    fill="none"
                                  />
                                </svg>
                              )}
                              <div className="flex flex-col gap-0 w-full overflow-hidden">
                                <span
                                  className="text-[#f8ffe8] text-[16px] font-semibold truncate block"
                                  title={tokenName}
                                >
                                  {tokenName || 'untitled coin'}
                                </span>
                                <span
                                  className="text-[#f500ff] text-[11px] tracking-wide font-medium truncate block"
                                  title={tokenSymbol}
                                >
                                  {tokenSymbol || 'coin'}
                                </span>
                              </div>
                            </div>
                                        <img
                                          src={chainLogos[uiChainId]}
                              alt="chain"
                              className="w-8 shrink-0"
                            />
                          </div>
                          <span className="text-sm text-[#f8ffe8]/80 leading-snug whitespace-pre-wrap">
                            {(
                              tokenDescription ||
                              "this will be your coin's public description."
                            ).slice(0, 1000)}
                          </span>
                          <div className="flex items-center gap-2 text-sm text-[#f8ffe8]/80">
                            <span className="font-semibold">max wallet:</span>
                            <span className="text-[#f8ffe8]">
                              {maxWallet === 100 ? 'no limit' : `${maxWallet}%`}
                            </span>
                          </div>
                          <div className="socials flex gap-[16px]">
                            {website && (
                              <a
                                href={website}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  alt="globe"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  src={web}
                                  className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity"
                                />
                              </a>
                            )}
                            {twitter && (
                              <a
                                href={twitter}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  alt="x"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  src={x}
                                  className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity"
                                />
                              </a>
                            )}
                            {telegram && (
                              <a
                                href={telegram}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  alt="telegram"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  src={tlg}
                                  className="w-5 h-5 opacity-70 hover:opacity-100 transition-opacity"
                                />
                              </a>
                            )}
                          </div>
                          {isConnected ? (
                            supportedChainIds.includes(
                              Number(selectedPoolChainId)
                            ) ? (
                              <button
                                disabled={
                                  !selectedPool ||
                                  tokenName === '' ||
                                  tokenSymbol === '' ||
                                  tokenDescription === '' ||
                                  tokenDescription.length > 1000 ||
                                  logoFile === null ||
                                  logoError !== '' ||
                                  (isChecked && apiKey === '') ||
                                  (isChecked && personality === '') ||
                                  chainFeeAmount +
                                    Number(depositAmount) +
                                    ((chainFeatureAmounts?.[featureOption] ??
                                      0)) >
                                    accountBalance
                                }
                                onClick={onHotcurveCreate}
                                className={
                                  !selectedPool ||
                                  tokenName === '' ||
                                  tokenSymbol === '' ||
                                  tokenDescription === '' ||
                                  tokenDescription.length > 1000 ||
                                  logoFile === null ||
                                  (isChecked && apiKey === '') ||
                                  (isChecked && personality === '') ||
                                  chainFeeAmount +
                                    Number(depositAmount) +
                                    ((chainFeatureAmounts?.[featureOption] ??
                                      0)) >
                                    accountBalance
                                    ? 'w-full px-5 py-3 rounded-lg text-center font-semibold text-[#bbb] bg-[#5f5f5f] cursor-not-allowed'
                                    : 'w-full px-5 py-3 rounded-lg text-center font-semibold text-white transition-all duration-200 bg-[#f500ff] hover:bg-[#ff66ff] active:bg-[#5e1bc4]'
                                }
                              >
                                {!selectedPool ||
                                tokenName === '' ||
                                tokenSymbol === '' ||
                                tokenDescription === '' ||
                                tokenDescription.length > 1000 ||
                                logoFile === null ||
                                (isChecked && apiKey === '') ||
                                (isChecked && personality === '') ||
                                chainFeeAmount +
                                  Number(depositAmount) +
                                  ((chainFeatureAmounts?.[featureOption] ??
                                    0)) >
                                  accountBalance ? (
                                  'create coin'
                                ) : creating ? (
                                  <ClipLoader
                                    color={'#fff'}
                                    loading={creating}
                                    size={22}
                                  />
                                ) : (
                                  'create coin'
                                )}
                              </button>
                            ) : (
                              <button
                                onClick={() => open({ view: 'Networks' })}
                                className="w-full px-5 py-3 rounded-lg text-center font-semibold text-white transition-all duration-200 bg-[#f500ff] hover:bg-[#ff66ff] active:bg-[#5e1bc4]"
                              >
                                <div className="flex items-center justify-center gap-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      d="M13 16h-1v-4h-1m4 0h-1a4 4 0 00-8 0h-1m6 4v1a4 4 0 11-8 0v-1"
                                    />
                                  </svg>
                                  <span>switch network</span>
                                </div>
                              </button>
                            )
                          ) : (
                            <button
                              onClick={() => open({ view: 'ConnectWallet' })}
                              className="w-full px-5 py-3 rounded-lg text-center font-semibold text-white transition-all duration-200 bg-[#f500ff] hover:bg-[#ff66ff] active:bg-[#5e1bc4]"
                            >
                              connect wallet to create
                            </button>
                          )}
                        </div>
                      </div>
                      <p className="text-xs text-center text-whit mt-2">
                        tip: coin data cannot be changed after creation
                      </p>
                    </aside>
                  </div>
                </section>
              </section>
            </div>
          </div>
        }
      </div>
      <Footer />
    </div>
  )
}

export default App
